import {useContext, useEffect, useState, useCallback, useRef} from 'react';
import {Button, Checkbox, Dialog, DialogActions, DialogContent, 
    DialogTitle, CircularProgress, Container, FormControlLabel, Grid, TextField,} from '@mui/material';
import {useParams, useHistory} from 'react-router-dom';
import {Controller, useForm} from 'react-hook-form';
import {CountryService, SectionService} from '../../../services';
import ValidationError from "../../shared/ValidationError";
import StatementModal from "./statement-modal";
import {NotificationContext} from "../../../components/NotificationContext";
import Prompt from "../../../customUtil/Prompt";
import { CurrentUserContext } from '../../../components/CurrentUserContext';

const CountryForm = () => {
    const methods = useForm();
    const {handleSubmit, control, setValue, errors} = methods;

    const [data, setData] = useState({});
    const {showMessage, showError} = useContext(NotificationContext);
    const [isReady, setIsReady] = useState(false);
    const {id} = useParams();
    const history = useHistory();
    const [block, setBlock] = useState(false);  
    const refSubmitButtom = useRef();
    const [open, setOpen] = useState(false);
    const [openConfirmation, setOpenConfirmation] = useState(false);
    const [openInfo, setOpenInfo] = useState(false);
    const [triggerExit, setTriggerExit] = useState({
        onOk: false,
        path: ""
      });
    const [isVisibleDialog, setVisibleDialog] = useState(false);
    const {rights} = useContext(CurrentUserContext);
     const [showProgress, setShowProgress] = useState(false);
    const handleGoToIntendedPage = useCallback(
        (location) => history.push(location),
        [history]
      );

      const handleClose = () => {
        setOpen(false);
        setOpenConfirmation(false);
        setOpenInfo(false);
    }
    const removeCountry = () => {
        setShowProgress(true);
        CountryService.delete(data.id).then((response) => {                
                showMessage('Successfully Deleted');
                history.push("/references/countries");   
                setShowProgress(false);                                
            }).catch((response) => {
            handleClose();
            setOpenInfo(true);
            setShowProgress(false);                                

        });
    }
    
      useEffect(() => {
       console.log(id)
        const unblock = history.block((location) => {
          if (location.pathname !== `/gas/account-statements/${id}`) {
            if(block){
                setVisibleDialog(true);   
                setTriggerExit({...triggerExit, path: location.pathname});
            }else{
                setVisibleDialog(false);   
                setTriggerExit({onOk: true, path: location.pathname});
            }
                           
              }
         
          if (triggerExit.onOk) {
            return true;
          }
          return false;
        });
        if (triggerExit.onOk) {
            handleGoToIntendedPage(triggerExit.path);
          }
        return () => {
          unblock();
        };
      }, [history, triggerExit.onOk, triggerExit.path, block]);
    const populateSections = () => {
        SectionService.getRoot().then((response) => {

        })
    }

    useEffect(() => {
        populateSections();
        if (id !== "new") {
            CountryService.getById(id)
                .then((response) => {
                    setData(response.data);
                    setIsReady(true);
                });
        } else {
            setData({statements: []});
            setIsReady(true);
        }
    }, [id, setValue]);


    const onSubmit = d => {
        setBlock(false);
        setVisibleDialog(false);
        if (data.id) {
            CountryService.update({...data, ...d}).then((response) => {
                showMessage('Country updated.');
            }).catch((err) => {
                showError(err.message);
            });
        } else {
            CountryService.create({...data, ...d}).then((response) => {
                setData(response.data);
                showMessage('Country Created.');
            }).catch((err) => {
                showError(err.message);
            });
        }
        setTimeout(() => {
            setIsReady(true);
            history.push('/references/countries')
        }, 100) 
    };

    const addStatement = (statement) => {
        let newData = {...data};
        data.countryStatements
            .push({
                statementId: statement.id,
                sectionId: statement.sectionId,
                statementOrder: 1,
                statements: statement.allContent
            });
        setData(newData);
    }

    const removeStatement = (statement) => {
        let newData = {...data};
        newData.countryStatements = data.countryStatements.filter(s => s.statementId !== statement.statementId);
        setData(newData)
    }

    if (!isReady) {
        return (
            <CircularProgress/>
        );
    }
    const triggerSubmit = () => {
        refSubmitButtom?.current?.click();
      };     
   
      const onSave = (event) => {
          console.log(event)
          triggerSubmit();
          setBlock(false);
          setVisibleDialog(false);
      }
  
      const checkModified = (event) => {
          if(event.type ===  "change"){
              setBlock(true);
                 }
              }
    return (
        <Container>
            <header>
                <h1>Country</h1>
            </header>

            <form style={{textAlign: 'left'}} onSubmit={handleSubmit(onSubmit)} onChange={event => {checkModified(event)}}>
            <Prompt
               visible={isVisibleDialog}
               onClose={() => setVisibleDialog(false)}
               onOk={() => {
               setTriggerExit({...triggerExit, onOk: true});
               setVisibleDialog(false);
               setBlock(false);
            }}
               onSave={onSave}
            />
                <Grid container>
                    <Grid item xs={12}>
                        <p>
                            Country to which shipment is sent to.
                        </p>
                    </Grid>
                    <Grid item xs={6}>
                        <Controller
                            name="countryCode"
                            control={control}
                            fullWidth
                            as={<TextField></TextField>}
                            label="Code"
                            color="primary"
                            defaultValue={data.countryCode}
                            rules={{required: 'Country code is required.'}}
                            variant="outlined"
                        />
                        <ValidationError error={errors.countryCode}/>
                    </Grid>
                    <Grid item xs={6}>
                    </Grid>
                    <Grid item xs={6}>
                        <br/>
                        <Controller
                            name="countryName"
                            control={control}
                            fullWidth
                            as={<TextField></TextField>}
                            label="Name"
                            color="primary"
                            variant="outlined"
                            rules={{required: 'Country Name is required.'}}
                            defaultValue={data.countryName}
                        />
                        <ValidationError error={errors.countryName}/>
                    </Grid>
                    <br/>

                    <Grid item xs={6}>
                    </Grid>
                    <Grid item xs={12}>
                        <hr/>
                    </Grid>
                    {data.id !== undefined && <>
                        <Grid item xs={3}>
                            <FormControlLabel label="Has Pre-Inspection" variant="outlined" control={
                                <Controller
                                    name="hasPreinspection"
                                    control={control}
                                    color="primary"
                                    variant="outlined"
                                    defaultValue={data.hasPreinspection}
                                    render={(
                                        {onChange, onBlur, value, name, ref},
                                        {invalid, isTouched, isDirty}
                                    ) => (
                                        <Checkbox
                                            onBlur={onBlur}
                                            onChange={(e) => {
                                                onChange(e.target.checked);
                                                setData({...data, hasPreinspection: e.target.checked})
                                            }}
                                            checked={value}
                                            inputRef={ref}
                                        />
                                    )}
                                />
                            }/>
                        </Grid>

                        <Grid item xs={9}>
                            {data.hasPreinspection &&
                                <div>
                                    <StatementModal data={data} onStatementAdd={addStatement}
                                                    onStatementRemove={removeStatement} sectionId={13}/>
                                </div>
                            }
                        </Grid>
                        <Grid item xs={12}>
                            <hr/>
                        </Grid>
                        <Grid item xs={3}>
                            <FormControlLabel label="Has Registration" variant="outlined" control={
                                <Controller
                                    name="hasRegistration"
                                    control={control}
                                    fullWidth
                                    color="primary"
                                    defaultValue={data.hasRegistration}
                                    render={(
                                        {onChange, onBlur, value, name, ref},
                                        {invalid, isTouched, isDirty}
                                    ) => (
                                        <Checkbox
                                            onBlur={onBlur}
                                            onChange={(e) => {
                                                onChange(e.target.checked)
                                                setData({...data, hasRegistration: e.target.checked})
                                            }}
                                            checked={value}
                                            inputRef={ref}
                                        />
                                    )}
                                />
                            }/>
                        </Grid>
                        <Grid item xs={9}>
                            {
                                data.hasRegistration &&
                                <StatementModal data={data} onStatementAdd={addStatement}
                                                onStatementRemove={removeStatement} sectionId={12}/>
                            }
                        </Grid>
                        <Grid item xs={12}>
                            <hr/>
                        </Grid>
                        <Grid item xs={3}>
                            <FormControlLabel label="Additional Info on Documents" variant="outlined" control={
                                <Controller
                                    name="hasAdditionalDocumentRequirements"
                                    control={control}
                                    fullWidth
                                    color="primary"
                                    defaultValue={data.hasAdditionalDocumentRequirements}
                                    render={(
                                        {onChange, onBlur, value, name, ref},
                                        {invalid, isTouched, isDirty}
                                    ) => (
                                        <Checkbox
                                            onBlur={onBlur}
                                            onChange={(e) => {
                                                onChange(e.target.checked)
                                                setData({...data, hasAdditionalDocumentRequirements: e.target.checked})
                                            }}
                                            checked={value}
                                            inputRef={ref}
                                        />
                                    )}
                                />
                            }/>
                        </Grid>
                        <Grid item xs={9}>
                            {
                                data.hasAdditionalDocumentRequirements &&
                                <StatementModal data={data} onStatementAdd={addStatement}
                                                onStatementRemove={removeStatement} sectionId={14}/>
                            }

                        </Grid>
                        <Grid item xs={12}>
                            <hr/>
                        </Grid>
                        <Grid item xs={3}>
                            <FormControlLabel label="Has Waiver" variant="outlined" control={
                                <Controller
                                    name="hasWaiver"
                                    control={control}
                                    fullWidth
                                    color="primary"
                                    defaultValue={data.hasWaiver}
                                    render={(
                                        {onChange, onBlur, value, name, ref},
                                        {invalid, isTouched, isDirty}
                                    ) => (
                                        <Checkbox
                                            onBlur={onBlur}
                                            onChange={(e) => {
                                                onChange(e.target.checked)
                                                setData({...data, hasWaiver: e.target.checked})
                                            }}
                                            checked={value}
                                            inputRef={ref}
                                        />
                                    )}
                                />
                            }/>
                        </Grid>
                        <Grid item xs={9}>
                            {
                                data.hasWaiver &&
                                <StatementModal data={data} sectionId={9} onStatementAdd={addStatement}
                                                onStatementRemove={removeStatement}/>
                            }
                        </Grid>
                    </>}
                    <Grid item xs={10}>
                            <Button variant="contained" color="primary" type="submit">Submit</Button>
                        </Grid>
                        {(rights.includes("ROLE_SI_ADMIN") && id !== 'new') &&                        
                        <Grid item xs={2}>
                            <Button variant="contained" color="danger" onClick={() => setOpenConfirmation(true)}>Remove Country</Button>
                        </Grid>
                      }
                </Grid>
                <button hidden={true} ref={refSubmitButtom} type={"submit"} />
            </form>
            <Dialog open={openConfirmation} onClose={handleClose} aria-labelledby="form-dialog-title">
                    <DialogTitle id="form-dialog-title">Confirm Delete</DialogTitle>
                    <DialogContent>                      
                          Are you sure you want to delete this country?                                           
                    </DialogContent>
                    <DialogActions>
                        {showProgress &&  <CircularProgress style={{width: "12px", height: "10px"}}/>}                       
                    <Button onClick={removeCountry} color="primary" disabled={showProgress}>
                            yes
                        </Button>
                        <Button onClick={handleClose} color="primary">
                            No
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog open={openInfo} onClose={handleClose} aria-labelledby="form-dialog-title">                   
                    <DialogContent>                       
                          This country can not be deleted because it is already in use.                                             
                    </DialogContent>
                    <DialogActions>                    
                        <Button onClick={handleClose} color="primary">
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>

        </Container>
    );
};

export default CountryForm;
